import {
  CountrySelect,
  FormInputOptions,
  SelectOption,
  FormNames,
  Toast,
} from '../common-types/base-types';

export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const EMAIL_AUTH_ERROR_CODE = {
  code: 'auth/email-already-in-use',
  message: 'Este correo electrónico ya ha sido registrado',
};

export const API_URL = process.env.REACT_APP_APIURL;

// Use this to consume local.
// export const API_URL = `http://localhost:4001/graphql`;

// Use this to consume dev
// export const API_URL = `https://fullcap-api-dev.herokuapp.com/graphql`;

// Use this to consume prod
// export const API_URL = `https://fullcap-api-prod.herokuapp.com/graphql` --> !!

export const BASE_COUNTRY_URL = 'https://api.countrystatecity.in/v1/';
export const CSC_API_KEY = process.env.REACT_APP_COUNTRYSTATECITY_API_KEY;

export const DEFAULT_COUNTRIES = [
  {
    id: 0,
    name: '',
    iso2: '',
  },
] as CountrySelect[];

const headers = new Headers();
headers.append('X-CSCAPI-KEY', CSC_API_KEY || '');
export const REQUEST_OPTIONS: RequestInit = {
  method: 'GET',
  headers,
  redirect: 'follow',
};

// # Region: Messages.

export const REQUIRED_FIELD_MESSAGE = `Este campo es requerido`;
export const PRE_INSCRIPTION_MESSAGE = `
 Cuando te pre inscribas deberás asistir presencialmente al torneo para poder proceder con el pago y asignarte una escarapela
`;

/**
 * Categorías del torneo disponibles
 * 1. Torneo masculino - Valor: 0
 * 2. Torneo femenino - Valor: 1
 * 3. Torneo mixto - Valor 2,
 */
export const TOURNAMENT_CATEGORIES = [
  {
    label: 'Torneo masculino',
    value: 'Masculino',
  },
  {
    label: 'Torneo femenino',
    value: 'Femenino',
  },
  {
    label: 'Torneo mixto',
    value: 'Mixto',
  },
] as SelectOption[];

/**
 * Categorías del torneo disponibles
 * 1. Torneo individual - Valor: 1
 * 2. Torneo en parejas - Valor: 2
 * 3. Torneo en equipos - Valor 4,
 */
export const TOURNAMENT_MODALITIES = [
  {
    label: 'Torneo individual',
    value: 'Individual',
  },
  {
    label: 'Torneo en parejas',
    value: 'Parejas',
  },
  {
    label: 'Torneo en equipos',
    value: 'Equipo',
  },
] as SelectOption[];

/**
 * Tipos de torneo
 * 1. Torneo flexible - Valor: 0
 * 2. Torneo rígido - Valor: 1
 */
export const TOURNAMENT_TYPE = [
  {
    label: 'Torneo flexible',
    value: 'Flexible',
  },
  {
    label: 'Torneo rígido',
    value: 'Rígido',
  },
] as SelectOption[];

/**
 * Numero de rondas posible van de 5 a 12
 */
export const ROUND_NUMBERS = [
  {
    label: '5 rondas',
    value: 5,
  },
  {
    label: '6 rondas',
    value: 6,
  },
  {
    label: '7 rondas',
    value: 7,
  },
  {
    label: '8 rondas',
    value: 8,
  },
  {
    label: '9 rondas',
    value: 9,
  },
  {
    label: '10 rondas',
    value: 10,
  },
  {
    label: '11 rondas',
    value: 11,
  },
  {
    label: '12 rondas',
    value: 12,
  },
] as SelectOption[];

// TODO: Need to organize the names to be consistent with the server names
export const TOURNAMENT_CAT = [
  {
    label: 'Internacional',
    value: 'Internacional',
  },
  {
    label: 'Nacional',
    value: 'Nacional',
  },
  {
    label: 'Departamental',
    value: 'Departamental',
  },
] as SelectOption[];

// Form Constants
export const INPUT_FIELDS = {
  [FormNames.FULLNAME]: {
    id: 'fullName',
    name: FormNames.FULLNAME,
    label: 'Nombre completo',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
  } as FormInputOptions,
  [FormNames.EMAIL]: {
    id: 'email',
    name: FormNames.EMAIL,
    label: 'Correo',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'email',
  } as FormInputOptions,
  [FormNames.PASSWORD]: {
    id: 'password',
    name: FormNames.PASSWORD,
    label: 'Contraseña',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'password',
  } as FormInputOptions,
  [FormNames.PHONE_NUMBER]: {
    id: 'phoneNumber',
    name: FormNames.PHONE_NUMBER,
    label: 'Celular',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'tel',
  } as FormInputOptions,
  [FormNames.GENDER]: {
    id: 'gender',
    name: FormNames.GENDER,
    label: 'Género',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
    options: [
      {
        value: 'Masculino',
        label: 'Hombre',
      },
      {
        value: 'Femenino',
        label: 'Mujer',
      },
    ],
  } as FormInputOptions,
  [FormNames.DOCUMENT_TYPE]: {
    id: 'documentType',
    name: FormNames.DOCUMENT_TYPE,
    label: 'Tipo de documento',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
    options: [
      {
        value: 'C.C',
        label: 'Cédula de ciudananía',
      },
      {
        value: 'T.I',
        label: 'Tarjeta de identidad',
      },
      {
        value: 'C.E',
        label: 'Cédula de extranjería',
      },
      {
        value: 'P.P',
        label: 'Pasaporte',
      },
    ],
  } as FormInputOptions,
  [FormNames.DOCUMENT]: {
    id: 'document',
    name: FormNames.DOCUMENT,
    label: 'Número de documento',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'number',
  } as FormInputOptions,
  [FormNames.COUNTRY]: {
    id: 'country',
    name: FormNames.COUNTRY,
    label: 'Escoge la ciudad donde vives',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
  } as FormInputOptions,
  [FormNames.STATE]: {
    id: 'state',
    name: FormNames.STATE,
    label: 'Escoge el departamento/estado/provincia donde vives',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
  } as FormInputOptions,
  [FormNames.CITY]: {
    id: 'city',
    name: FormNames.CITY,
    label: 'Escoge la ciudad donde vives',
    fieldOptions: {
      required: true,
      message: REQUIRED_FIELD_MESSAGE,
    },
    type: 'text',
  } as FormInputOptions,
  [FormNames.CLUBNAME]: {
    id: 'clubName',
    name: FormNames.CLUBNAME,
    label: 'Club donde pertences',
    fieldOptions: {
      required: false,
    },
    type: 'text',
    placeholder: 'Si perteneces a algún club, escríbelo',
  } as FormInputOptions,
};

export const SUCCESS_TOAST: Toast = {
  isOpen: true,
  message: 'Ronda generada exitosamente',
  type: 'success',
};

export const ERROR_GENERIC_TOAST: Toast = {
  isOpen: true,
  message: 'Ocurrió un problema, intente nuevamente',
  type: 'error',
};

export const SUCCESS_SAVE_TOAST: Toast = {
  isOpen: true,
  message: 'Ronda guardada exitosamente',
  type: 'success',
};

export const ERROR_WORKER: Toast = {
  isOpen: true,
  message:
    'Ocurrió un error generando las rondas, contacta al administrador si el error persiste',
  type: 'error',
};

export const SUCCESS_ADD_TO_TOURNAMENT: Toast = {
  isOpen: true,
  message: 'Usuario agregado al torneo correctamente',
  type: 'success',
};

export const SUCCESS_DELETE_TO_TOURNAMENT: Toast = {
  isOpen: true,
  message: 'Usuario eliminado del torneo correctamente',
  type: 'success',
};

export const SUCCESS_UPDATE_ROUND: Toast = {
  isOpen: true,
  message: 'Ronda actualizada correctamente',
  type: 'success',
};
